import { Box, Slider, Stack, Typography } from '@mui/material';
import NumberInput from '~/components/Inputs/NumberInput';

interface SymmetricMarginControlsProps {
    margin: number;
    onMarginChange: (value: number) => void;
}

const inputStyle = {
    textAlign: 'center' as const,
    width: '50px',
    fontSize: 13,
    paddingTop: 5,
    paddingBottom: 4,
};

export default function SymmetricMarginControls({
    margin,
    onMarginChange,
}: SymmetricMarginControlsProps) {
    const sliderMax = 5;

    const handleChange = (value: number | null) => {
        onMarginChange(value ?? 0);
    };

    return (
        <Box>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mb={0.5}
            >
                <Typography fontSize={12} color="text.secondary">
                    Margin
                </Typography>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <NumberInput
                        value={margin}
                        onChange={handleChange}
                        min={0}
                        max={sliderMax}
                        step={0.1}
                        precision={1}
                        inputProps={{ style: inputStyle }}
                    />
                    <Typography fontSize={12} color="text.secondary">
                        cm
                    </Typography>
                </Stack>
            </Stack>

            <Slider
                value={margin}
                onChange={(_, value) => onMarginChange(value as number)}
                min={0}
                max={sliderMax}
                step={0.1}
                valueLabelDisplay="auto"
                valueLabelFormat={(value) => `${value.toFixed(1)} cm`}
            />
        </Box>
    );
}
